import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { FaEnvelope, FaPhone, FaLinkedin } from 'react-icons/fa';

const Contact = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <section id="contact" className="container" ref={ref} style={{ minHeight: '80vh' }}>
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.95 }}
        transition={{ duration: 0.6 }}
        className="glass-panel"
        style={{ padding: '4rem', textAlign: 'center', position: 'relative', overflow: 'hidden' }}
      >
        <div style={{
          position: 'absolute', top: 0, right: 0, width: '300px', height: '300px',
          background: 'radial-gradient(circle, rgba(0,240,255,0.1) 0%, transparent 70%)',
          pointerEvents: 'none'
        }}></div>

        <h2 className="section-title" style={{ marginBottom: '1.5rem' }}>
          Let's <span className="text-gradient">Connect</span>
        </h2>
        <p style={{ color: 'var(--text-secondary)', fontSize: '1.2rem', maxWidth: '600px', margin: '0 auto 3rem auto' }}>
          Ready to drive digital transformation and scale your platforms? Let's discuss how we can innovate together.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', alignItems: 'center' }}>
          <motion.a 
            whileHover={{ scale: 1.05, background: 'rgba(255,255,255,0.1)' }}
            href="mailto:a.ravikishan@gmail.com"
            style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '15px 30px', borderRadius: '30px', border: '1px solid var(--glass-border)', background: 'var(--glass-bg)', color: '#fff', fontSize: '1.1rem', width: 'fit-content' }}
          >
            <FaEnvelope color="var(--accent-cyan)" /> a.ravikishan@gmail.com
          </motion.a>
          
          <motion.a 
            whileHover={{ scale: 1.05, background: 'rgba(255,255,255,0.1)' }}
            href="tel:+918008668686"
            style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '15px 30px', borderRadius: '30px', border: '1px solid var(--glass-border)', background: 'var(--glass-bg)', color: '#fff', fontSize: '1.1rem', width: 'fit-content' }}
          >
            <FaPhone color="var(--accent-purple)" /> +91 8008668686
          </motion.a>
          
          <motion.a 
            whileHover={{ scale: 1.05, background: 'rgba(255,255,255,0.1)' }}
            href="https://www.linkedin.com/in/aravikishan/" target="_blank" rel="noreferrer"
            style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '15px 30px', borderRadius: '30px', border: '1px solid var(--glass-border)', background: 'var(--glass-bg)', color: '#fff', fontSize: '1.1rem', width: 'fit-content' }}
          >
            <FaLinkedin color="#0077b5" /> LinkedIn Profile
          </motion.a>
        </div>
      </motion.div>
      <footer style={{ textAlign: 'center', padding: '2rem 0', color: 'var(--text-secondary)', marginTop: '4rem', fontSize: '0.9rem' }}>
        <p>© {new Date().getFullYear()} A. Ravi Kishan. All Rights Reserved.</p>
      </footer>
    </section>
  );
};

export default Contact;
